// hooks/useCitationViewer.js
import { useCallback, useState } from 'react';
import config from 'core/config';

const resolveDocumentUrl = (url) => {
    if (!url) return '';
    // A URL-ingested source's citation.url is already absolute; a locally
    // stored document's is a relative ViewPDF path (documents/views.py).
    if (/^https?:\/\//i.test(url)) return url;
    return `${config.DJANGO_ORIGIN}${url}`;
};

// Selecting a citation opens the PDF viewer immediately, scrolled to the cited
// page - there's no separate "fetch the source" step. ViewPDF serves the file
// with Range support, so react-pdf/pdf.js only ever downloads the byte ranges
// it needs to render that page, not the whole document.
export const useCitationViewer = () => {
    const [viewer, setViewer] = useState(null); // { page, trustName, source, quote, section, pdfUrl, ... } | null
    const [error, setError] = useState(null);

    const closeViewer = useCallback(() => {
        setViewer(null);
        setError(null);
    }, []);

    const dismissError = useCallback(() => setError(null), []);

    const openCitation = useCallback((citation) => {
        if (!citation) return;

        const pdfUrl = resolveDocumentUrl(citation.url);
        if (!pdfUrl) {
            setError('This citation has no source document available.');
            return;
        }

        setError(null);
        setViewer({
            ...citation,
            page: citation.page || 1,
            trustName: citation.trust_name,
            pdfUrl,
        });
    }, []);

    const handleLoadError = useCallback((err) => {
        console.error('Failed to open citation source:', err);
        setError('This source document could not be opened.');
    }, []);

    return { viewer, error, openCitation, closeViewer, dismissError, handleLoadError };
};
